import script from "./AppModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppModal.vue?vue&type=script&setup=true&lang=ts"

import "./AppModal.vue?vue&type=style&index=0&id=5cb6684c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb6684c"]])

export default __exports__